import Cookies from "js-cookie";
import EnvironmentService from "./environmentService";

export default class TaskCommentService {

    constructor() {
        this.environmentService = new EnvironmentService();
    }

    async retrieveComments(taskUUID) {
        const queryString = "?TaskUUID=" + encodeURIComponent(taskUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/TaskComment" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token")
                }
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }

    async addCommentToTask(taskUUID, commentText) {
        let commentObject = {
            CommentText: commentText
        };

        const queryString = "?TaskUUID=" + encodeURIComponent(taskUUID);

        let result = await fetch(this.environmentService.getEnvironmentHost() + "/api/TaskComment" + queryString,
            {
                headers:
                {
                    "Authorization": "Bearer " + Cookies.get("access_token"),
                    "Content-type": "application/json"
                },
                method: "POST",
                body: JSON.stringify(commentObject)
            });
        let responseOK = result && result.ok;
        if (responseOK) {
            let data = await result.json();
            return data;
        }
        else {
            return result;
        }
    }
}


// WEBPACK FOOTER //
// ./src/service/taskCommentService.js